import { Dropdown } from 'Components/Dropdown';
import React, { useCallback, useRef, useState } from 'react';
import { ArrowDownSvg } from 'common/ui/themes/disona/icons';
import { SvgWrapper } from 'common/ui/themes/disona/atoms/SvgWrapper';
import SmoothArrowSrc from './smooth-arrow.svg';
import * as S from './styled';

const Popover = ({
  options = [],
  onChange,
  value,
  shadow,
  label,
  placement = 'top',
}) => {
  const [open, setOpen] = useState(false);
  const isActive = useCallback((item) => value === item.value, [value]);
  const arrowRef = useRef(null);
  const getSelectedOption = useCallback(
    () => options.find((item) => item.value === value),
    [options, value]
  );

  return (
    <Dropdown
      offset={4}
      arrow={{
        element: arrowRef,
      }}
      placement={placement}
      open={open}
      setOpen={setOpen}
      render={({ middlewareData, placement }) => {
        const { arrow } = middlewareData;
        return (
          <S.Options shadow={shadow}>
            <S.FloatingArrow
              ref={arrowRef}
              placement={placement.split('-')[0]}
              left={arrow?.x}
              src={SmoothArrowSrc}
              alt=""
            />
            {options.map((item) => (
              <S.Option
                isActive={isActive(item)}
                onClick={() => {
                  !isActive(item) && onChange && onChange({ item, setOpen });
                }}
                key={item.key}
              >
                {item.label}
              </S.Option>
            ))}
          </S.Options>
        );
      }}
    >
      <S.Trigger>
        <p>{label}</p>
        <S.SelectedValue isOpen={open}>
          {getSelectedOption()?.label}
          <S.Arrow isOpen={open}>
            <SvgWrapper color={open ? '#00D1DF' : 'white'} width="8px">
              <ArrowDownSvg />
            </SvgWrapper>
          </S.Arrow>
        </S.SelectedValue>
      </S.Trigger>
    </Dropdown>
  );
};

export { Popover };
